import { render } from "./StaffDashboard.vue?vue&type=template&id=a5646eba&scoped=true"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"

import "./StaffDashboard.vue?vue&type=style&index=0&id=a5646eba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5646eba"]])

export default __exports__